module.exports = __webpack_public_path__ + "static/icon_slide_arrow_next-450deb5ace16019247c2a00c1ce4e59c.png";